export const environment = {
    production: false,
    umsUrl: "https://umsapinode.dev10.in/",
    user_token: 'TmpNPU0yTTJaVEJpT0dFNVl6RTFNakkwWVRneU1qaGlPV0U1T0dOaE1UVXpNV1E9TlRjNE1HVXdPRE00Wm1KaFpHSTRNMlF3WXpjeFpUQm1aV1ZqTmpSbU5EZz1NMk0yWlRCaU9HRTVZekUxTWpJMFlUZ3lNamhpT1dFNU9HTmhNVFV6TVdRPTE1Njk0NzgyNjE=',
    umsApp_id: 13,
    recaptchaKey: '6Lc4aOIjAAAAAJG0LE_Oyd8Nn3pUEC_5ZIpwzeng',
    is_captcha: false,  
    swaggerUIUrl: 'https://apis.dev10.in/estaterapi/swagger.json',
    apiBaseUrl: 'https://apis.dev10.in/estaterapi/v1/',
    marketsUrl: 'https://mireportsapi.dev10.in/v1/',
    markets_api_key: '00cc456ac4963d000af6c114dcf89825',
}
